import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ArenaRecording {
  id: string;
  arena_id: string | null;
  arena_name: string;
  arena_type: string | null;
  duration_seconds: number | null;
  participant_count: number | null;
  pop_count: number | null;
  video_url: string | null;
  thumbnail_url: string | null;
  recorded_at: string;
  created_at: string | null;
}

export const useArenaRecordings = () => {
  const [recordings, setRecordings] = useState<ArenaRecording[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchRecordings = async () => {
    try {
      const { data, error } = await supabase
        .from('arena_recordings')
        .select('*')
        .order('recorded_at', { ascending: false })
        .limit(20);

      if (error) throw error;

      setRecordings(data || []);
    } catch (error) {
      console.error('Error fetching arena recordings:', error);
      setRecordings([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecordings();

    // Subscribe to new recordings
    const channel = supabase
      .channel('arena-recordings')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'arena_recordings'
        },
        (payload) => {
          setRecordings(prev => [payload.new as ArenaRecording, ...prev]);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return { recordings, loading, refetch: fetchRecordings };
};
